import { Navigate, Outlet } from 'react-router-dom';
import { getLocalStorage } from '../../API/Api';

const AuthGuard = () => {
  let token = getLocalStorage('apiToken');
  return <>{token ? <Outlet /> : <Navigate replace to='/' />}</>;
};

export default AuthGuard;
